import { ErpRuleHelpInformationResponse, PaginatedItemsResponse } from 'com.cogvio.pricemonitor.api';
import { apiClientMutator } from '~/infrastructure/config/mutator';

export function getErpHelp() {
	const fetchData = async () => {
		const data = await apiClientMutator<PaginatedItemsResponse<ErpRuleHelpInformationResponse>>({
			url: '/erp/rules-help',
			method: 'get',
		});
		return data;
	};
	return fetchData();
}
